module.exports = __webpack_public_path__ + "img/in-xaas.5ac98f7.svg";